import React from 'react'

// definitions
import { AppState } from '../../../App.d'
import { StripeOrgAccountXeroOrgBankFeed } from '../../../../../back-end/common/stripeOrgAccountXeroOrgBankFeed'

// utilities
import * as Request from '../../../utilities/request'

// The SubSync Stripe Bank Feed connection for the currently selected mapping. Lives at the settings screen level
// rather than inside BankFeedSettings because two siblings need it: BankFeedSettings (connect/disconnect UI) and
// OrgMappingHeader (which must not warn "we couldn't detect a Stripe Bank Feed" when one is connected). The
// settings screen renders a single mapping at a time, so this is still one request.
const useBankFeed = (stripeOrgAccountXeroOrgID: string | undefined, appState: AppState, onError: (message: string) => void) => {
	const [bankFeed, setBankFeed] = React.useState<StripeOrgAccountXeroOrgBankFeed | undefined>(undefined)
	const [loadingBankFeed, setLoadingBankFeed] = React.useState<boolean>(true)

	const reloadBankFeed = React.useCallback(async () => {
		if (!stripeOrgAccountXeroOrgID) {
			// An unsaved mapping has no ID yet. Clear the initial loading state or it latches on forever
			// and the caller shows a permanent "Loading connection status...".
			setLoadingBankFeed(false)
			return
		}
		setLoadingBankFeed(true)
		try {
			const res = await Request.get(`bankfeed/connection?where=StripeOrgAccountXeroOrgID==${stripeOrgAccountXeroOrgID}`, appState.authState)
			setBankFeed(res.data.stripeOrgAccountXeroOrgBankFeeds?.[0])
		} catch (e) {
			onError('Unable to load Bank Feed connection status')
		} finally {
			setLoadingBankFeed(false)
		}
	}, [stripeOrgAccountXeroOrgID]) // eslint-disable-line

	React.useEffect(() => {
		reloadBankFeed()
	}, [reloadBankFeed])

	return { bankFeed, loadingBankFeed, reloadBankFeed }
}

export { useBankFeed }
